export const NO_ROOF_WINDOW = 'no_roof_window';
